/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  DocumentDraftingRequest,
  DocumentDraftingResponse,
  HTTPValidationError,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Api<
  SecurityDataType = unknown
> extends HttpClient<SecurityDataType> {
  /**
   * @description Genera documentos jurídicos según el ordenamiento jurídico colombiano
   *
   * @tags documents
   * @name DraftDocumentEndpointApiV1DraftDocumentPost
   * @summary Generación de Documentos Jurídicos
   * @request POST:/api/v1/draft-document
   */
  draftDocumentEndpointApiV1DraftDocumentPost = (
    data: DocumentDraftingRequest,
    params: RequestParams = {}
  ) =>
    this.request<DocumentDraftingResponse, HTTPValidationError>({
      path: `/api/v1/draft-document`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Genera documentos personalizados según especificaciones del usuario
   *
   * @tags documents
   * @name DraftCustomDocumentEndpointApiV1DraftCustomDocumentPost
   * @summary Generación de Documentos Personalizados
   * @request POST:/api/v1/draft-custom-document
   */
  draftCustomDocumentEndpointApiV1DraftCustomDocumentPost = (
    data: DocumentDraftingRequest,
    params: RequestParams = {}
  ) =>
    this.request<DocumentDraftingResponse, HTTPValidationError>({
      path: `/api/v1/draft-custom-document`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
